import { inject, computed } from 'vue'

export function useLandingFlow() {
    const LandingStates = inject('LandingStates')

    const profile = computed(() => {
        return LandingStates.profile
    })
    const query = computed(() => {
        return LandingStates.query
    })
    const blobWebLanding = computed(() => {
        return LandingStates.blobWebLanding
    })

    const campaign = computed(() => {
        return LandingStates.campaign
    })

    return {
        profile,
        query,
        campaign,
        blobWebLanding
    }
}